import React from 'react';
import Home from '../components/Home';
import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Portfolio from '../components/Portfolio';
import Education from '../components/Education';
import Projects from '../components/Projects';
import Footer from '../components/Footer';

function MainPage() {
  return (
    <main className="main-page">
      <Home />
      <About />
      <Education />
      <Experience />
      <Portfolio />
      <Skills />
      <Projects />
      <Footer />
    </main>
  );
}

export default MainPage;
